module.exports = __webpack_public_path__ + "static/media/MIM.e493c2ae.webp";